module.exports = __webpack_public_path__ + "static/media/duplicate1.c91ebc9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Managing/duplicate1.jpg
// module id = 1633
// module chunks = 0